<template>
    <div class="row">
        <div class="col-lg-12">
            <h1 class="page-header">Meus Compromissos</h1>

            <!-- Lista de compromissos -->
            <div class="col-xs-12">
                <list 
                    ref="vuetable" 
                    :show-empty="true" 
                    api-url="planogoverno/compromisso-profile"
                    report-title="Meus Compromissos" 
                    :fields="fields" 
                    :initial-page="1" 
                    :appendParams="filtros"
                >
                    <template slot="filters">
                        <div class="collapse" id="filtros">

                            <!-- Filtro por período -->
                            <div class="col-sm-4">
                                <label class="custom-font">Período</label>
                                <select class="form-control select-selected" v-model="filtros.periodo">
                                    <option value="">Todos</option>
                                    <option v-for="(value, index) in periodos" :value="value" :key="index">
                                        {{ value }}
                                    </option>
                                </select>
                            </div>

                            <!-- Filtro por status -->
                            <div class="col-sm-4">
                                <label class="custom-font">Status</label>
                                <select class="form-control select-selected" v-model="filtros.status">
                                    <option value="">Todos</option>
                                    <option v-for="(value, index) in status" :value="value" :key="index">
                                        {{ value }}
                                    </option>
                                </select>
                            </div>

                            <!-- Filtro buttons -->
                            <div class="col-sm-4" style="padding-top: 15px;">
                                <button 
                                    @click="$refs.vuetable.refresh()" 
                                    class="btn btn-default margem-topo"
                                    name="btnFiltrar"
                                >
                                    <font-awesome-icon :icon="'filter'" />
                                    Filtrar
                                </button>
                                <button 
                                    @click="resetFiltros()" 
                                    class="btn btn-default margem-topo" 
                                    name="btnLimpar"
                                >
                                    <font-awesome-icon :icon="'eraser'" />
                                    Limpar Filtros
                                </button>
                            </div>
                        </div>
                    </template>

                    <template slot="actions">
                        <button 
                            class="btn btn-default" 
                            data-toggle="collapse" 
                            data-target="#filtros"
                        >
                            <font-awesome-icon :icon="'filter'" /> Filtros
                        </button>
                    </template>

                    <template slot="rowrender" slot-scope="props">
                        <div v-if="props.rowData.justificativa_cancelamento && props.rowData.status !== 'Cancelado'">
                            <p>Pedido de cancelamento pendente.</p>
                        </div>

                        <div v-else>
                            <button 
                                title="Informações" 
                                type="button" 
                                class="btn btn-primary"
                                @click="info(props.rowData)"
                            >
                                <font-awesome-icon :icon="'info'" class="icon" />
                            </button>

                            <router-link 
                                class="btn btn-primary" 
                                :to="{ 
                                    name: 'admin_planogoverno_details', 
                                    params: { id: props.rowData.id }
                                }"
                            >
                                <font-awesome-icon :icon="'search'" class="icon" />
                            </router-link>

                            <button 
                                title="Homologar" 
                                type="button" 
                                :disabled="props.rowData.status !== 'Em andamento'
                                    || props.rowData.status === 'Concluído'
                                    || props.rowData.status === 'Cancelado'
                                    || props.rowData.status === 'Rejeitada'"
                                class="btn btn-primary"
                                @click="homologar(props.rowData)"
                            >
                                <font-awesome-icon :icon="'check'" class="icon" />
                            </button>

                            <button 
                                title="Cancelar" 
                                type="button" 
                                :disabled="props.rowData.status === 'Cancelado'
                                    || props.rowData.status === 'Rejeitada' 
                                    || props.rowData.status === 'Concluído'
                                    || props.rowData.qtd_cancelamento === 3"
                                class="btn btn-danger" 
                                @click="cancelar(props.rowData)"
                            >
                                <font-awesome-icon :icon="'times'" class="icon" />
                            </button>
                        </div>
                    </template>
                </list>
            </div>

            <SidePlanoGoverno 
                ref="side" 
                :navs="sideConfig" 
                @homologar="homologarCompromisso"
                @cancelar="cancelarCompromisso" 
                @fechaModal="fecharSideModal"    
            />

        </div>
    </div>
</template>

<script>
import list from '@/components/common/DataTable'
import SidePlanoGoverno from '@/components/planogoverno/SidePlanoGoverno.vue'
import { request } from '@/request'

export default {
    components: { list, SidePlanoGoverno },
    data() {
        return {
            fields: [
                {
                    name: 'periodo',
                    title: 'Período',
                    filterable: true,
                    titleClass: 'text-center text-nowrap',
                    dataClass: 'text-center text-nowrap'
                },
                {
                    name: 'descritivo',
                    title: 'Compromisso',
                    filterable: true
                },
                {
                    name: 'status',
                    title: 'Status',
                    filterable: true,
                    titleClass: 'text-center text-nowrap',
                    dataClass: 'text-center text-nowrap'
                },
                {
                    name: '__slot:actions',
                    title: 'Ações',
                    titleClass: 'text-center col-md-3',
                    dataClass: 'text-center'
                }
            ],
            filtros: {
                periodo: '',
                status: ''
            },
            periodos: [
                '2021-2024',
                '2025-2028'
            ],
            status: [
                'Não Iniciado', 'Em andamento', 'Concluído', 'Cancelado'
            ],
            sideConfig: [
                {
                    titulo: 'Homologar',
                    subtitulo: '',
                    subtDetalhe: '',
                    largura: 900,
                    identidade: 'homologar',
                    abreProximo: false,
                    aberto: false,
                    data: null
                },
                {
                    titulo: 'Informações',
                    subtitulo: '',
                    subtDetalhe: '',
                    largura: 900,
                    identidade: 'info',
                    abreProximo: false,
                    aberto: false,
                    data: null
                },
                {
                    titulo: 'Cancelar',
                    subtitulo: '',
                    subtDetalhe: '',
                    largura: 500,
                    identidade: 'pedido-cancelamento',
                    abreProximo: false,
                    aberto: false,
                    data: null
                }
            ],
        }
    },
    methods: {
        async info(compromisso) {
            const painel = this.sideConfig.find(p => p.identidade === 'info')

            painel.subtitulo = compromisso.descritivo;
            painel.data = compromisso;
            this.$refs.side.$emit('abreModal', painel.identidade);
        },
        async homologar(compromisso) {
            const painel = this.sideConfig.find(p => p.identidade === 'homologar')
            painel.subtitulo = compromisso.descritivo;
            painel.data = compromisso;
            
            this.$refs.side.$emit('abreModal', painel.identidade);
        },
        cancelar(compromisso) {
            const painel = this.sideConfig.find(p => p.identidade === 'pedido-cancelamento')
            painel.subtitulo = compromisso.descritivo
            painel.data = compromisso

            this.$refs.side.$emit('abreModal', painel.identidade)
        },
        async homologarCompromisso(compromissoId) {
            const [now] = new Date().toISOString().split('T')

            const { status } = await request.put(
                `planogoverno/compromisso-profile/${compromissoId}`,
                { status: 'Concluído', data_conclusao: now }
            )

            if (status != 200) return this.$toastr.e('Erro ao homologar o compromisso.')

            this.$refs.vuetable.refresh()
            this.$toastr.s('Compromisso homologado com sucesso!')
            this.$refs.side.$emit('fechaModal', this.sideConfig[0].identidade)
        },
        async cancelarCompromisso({compromisso, justificativa}) {
            if (!justificativa || justificativa.trim() === '') {
                return this.$toastr.e('A justificativa é obrigatória para solicitar o cancelamento.');
            }

            const qtdCancelamento = compromisso.qtd_cancelamento + 1;

            const { status } = await request.put(
                `planogoverno/compromisso-profile/${compromisso.id}`,
                { 
                    justificativa_cancelamento: justificativa,
                    qtd_cancelamento: qtdCancelamento
                }
            )

            if (status != 200) return this.$toastr.e('Erro ao solicitar o cancelamento do compromisso.')

            this.$refs.vuetable.refresh()
            this.$toastr.s('Solicitação de cancelamento enviada com sucesso!')
            this.$refs.side.$emit('fechaModal', this.sideConfig[2].identidade)
        },
        async cancelarAcoes(compromisso) {
            const acoes = compromisso.acoes

            if (acoes && Array.isArray(acoes)) {
                acoes.forEach(async (acao) => {
                    if (acao.status !== 'Cancelada' || acao.status !== 'Rejeitada') {
                        try {
                            await request.put(
                                `planogoverno/compromisso-acao/${acao.id}`,
                                {
                                    justificativa_rejeicao: 'Compromisso cancelado',
                                    status: 'Cancelada'
                                }
                            )
                        } catch (err) {
                            console.error(`Erro ao cancelar a ação ${acao.id}: `, err)
                        }
                    }
                })
            }
        },
        fecharSideModal(identidade) {
            this.$refs.side.$emit('fechaModal', identidade)
        },
        resetFiltros() {
            this.filtros.periodo = ''
            this.filtros.status = ''
        }
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 100%;
    max-width: 500px;
    margin: 0px auto;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    font-family: 'Helvetica Neue', Arial, sans-serif;
    overflow: visible;
}

.modal-title {
    margin-top: 0;
    color: #00615c;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e5e5e5;
}

.modal-footer {
    margin-top: 15px;
    text-align: right;
    border-top: 1px solid #e5e5e5;
}

.custom-font {
    font-size: 16px;
    color: #00615c;
}

.icon {
    min-width: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/plano-governo/compromisso/MeusCompromissos.vue